import img1 from "../../assets/images/myaniture/newpd1";
import img2 from "../../assets/images/myaniture/newpd2";
import img3 from "../../assets/images/myaniture/newpd3";
import img4 from "../../assets/images/myaniture/newpd4";
import img5 from "../../assets/images/myaniture/newpd5";
import img6 from "../../assets/images/myaniture/newpd6";
export const newPd = [
  {
    id: 1,
    img: img1,
    name: "SMYCKA Artificial garland, inoutdoor, 1.5 m",
    price: "4,900 ",
  },
  {
    id: 2,
    img: img2,
    name: "SLIBB Washing bag, white",
    price: "4,900 ",
  },
  {
    id: 3,
    img: img3,
    name: "GLIMMA Unscented tealight",
    price: "25,900 ",
  },
  {
    id: 4,
    img: img4,
    name: "SMÄLLSPIREA Tealight holder, clear glasspatterned, 4 cm",
    price: "10,900  ",
  },
  {
    id: 5,
    img: img5,
    name: "GALEJ Tealight holder",
    price: "6,900 ",
  },
  {
    id: 6,
    img: img6,
    name: "ENSTAKA Scented tealight, Bonfiregrey, 3.5 hr",
    price: "16,900",
  },
];
